export const displaysHeaders = [
  {
    title: 'Název',
    align: 'left',
    sortable: true,
    key: 'name',
    width: "20%"
  },
  {
    title: 'URL',
    align: 'left',
    sortable: true,
    key: 'id',
    width: "30%"
  },
  {
    title: 'Paralelních zobrazení',
    align: 'center',
    sortable: false,
    key: 'mode',
    width: "15%"
  },
  {
    title: 'Perioda obnovy obsahu [s]',
    align: 'center',
    sortable: false,
    key: 'period',
    width: "15%"
  },
  {
    title: 'Akce',
    align: 'center',
    sortable: false,
    key: 'actions',
    width: "20%"
  }
];
